// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { zkFairTestnet as _zkFairTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the zkFairTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 43851
 * Chain Name: ZKFair Testnet
 * Default Block Explorer: https://testnet-scan.zkfair.io
 * Default RPC URL: https://testnet-rpc.zkfair.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { zkFairTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: zkFairTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const zkFairTestnet = createCommon({
	..._zkFairTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
